import React, {useState} from 'react';
import {SideMenuItems} from './SideMenuList';
import SideSubMenu from '../side-sub-menu/SideSubMenu';
import {TransformValues} from '../../utils/helper';
import {useNavigate} from 'react-router-dom';
import {Lock} from '../../ui-components/Iconpack';
import {TransformationType} from '../../screens/TransformationV2/Transformation';

interface SideMenuProps {
    isEmbedded: boolean;
    onTransformValuesChange: (values: TransformValues) => void;
    transformationObject: TransformValues;
    addTransformation: (t: TransformationType) => void;
    removeTransformation: (t: TransformationType) => void;
    cdnUrl?: string;
    isBulkEdit?: boolean;
}

export default function SideMenu({
    isEmbedded,
    onTransformValuesChange,
    transformationObject,
    addTransformation,
    removeTransformation,
    cdnUrl,
    isBulkEdit,
}: SideMenuProps) {
    const navigate = useNavigate();
    const [activeItem, setActiveItem] = useState(0);
    const [transformValues, setTransformValues] = useState<TransformValues>({});
    const [showSubMenu, setShowSubMenu] = useState(window.innerWidth >= 768);

    const handleItemClick = (index: number) => {
        setActiveItem(index);
        setShowSubMenu(true);
    };

    const hideSubmenu = () => {
        setShowSubMenu(false);
    };

    const handleUpgrade = () => {
        navigate('/settings/plans', {replace: true});
    };

    const handleTransformValuesChange = (values: TransformValues) => {
        setTransformValues(values);
        onTransformValuesChange(values);
    };

    return (
        <>
            <div
                className='fixed bottom-0 w-full overflow-x-auto bg-[#3E4784] md:relative md:h-full md:w-auto md:min-w-[75px] md:overflow-hidden'
                style={{scrollbarWidth: 'none'}}>
                <ul className='flex items-center  justify-start pt-3 md:flex-col md:justify-center md:gap-4 md:pt-4'>
                    {SideMenuItems.map((item, index) => {
                        if (isEmbedded && item.title === 'Caption') {
                            return null;
                        }
                        if (isBulkEdit && (item.title === 'Caption' || item.title === 'Background')) {
                            return null;
                        }
                        return (
                            <li className='flex flex-col items-center justify-center' key={item.title}>
                                <div
                                    className={`
                                    cursor-pointer items-center justify-center rounded-[6px] p-[12px] md:mx-[16px]
                                    ${activeItem === index ? 'border-[2px] border-[#4E5BA6] bg-[#717BBC]' : 'bg-[#363F72]'}`}
                                    onClick={() => handleItemClick(index)}>
                                    <item.icon color={activeItem === index ? '#FFFFFF' : '#B3B8DB'} />
                                </div>
                                <span
                                    className={`mx-[16px] pt-2 text-[12px] text-[#FFFFFF]
                                    ${activeItem === index ? 'font-[700]' : 'font-[400]'}`}>
                                    {item.title}
                                </span>
                            </li>
                        );
                    })}
                </ul>
            </div>

            {showSubMenu && (
                <SideSubMenu onClose={hideSubmenu}>
                    {SideMenuItems[activeItem].componentView({
                        transformValues,
                        onTransformValuesChange: handleTransformValuesChange,
                        transformationObject,
                        addTransformation,
                        removeTransformation,
                        cdnUrl,
                        isBulkEdit,
                    })}
                    {transformationObject.upgradeRequired && (
                        <div
                            className={
                                'absolute inset-0 h-full rounded-2xl bg-[#101828] bg-opacity-[0.7] p-2 px-4 pt-40'
                            }>
                            <div
                                className={
                                    'flex flex-col justify-center gap-10 rounded-2xl bg-transparent text-center'
                                }>
                                <span className={'text-inter text-[16px] font-[700] text-[#FFFFFF]'}>
                                    Upgrade to unlock this feature
                                </span>
                                <div
                                    className={
                                        'flex justify-center gap-3 bg-gradient-to-r from-[#FFB800] to-[#FFF500] ' +
                                        'text-inter cursor-pointer rounded-2xl py-2 text-[20px] font-[700] text-[#000]'
                                    }
                                    onClick={handleUpgrade}>
                                    <Lock />
                                    <span>Upgrade</span>
                                </div>
                            </div>
                        </div>
                    )}
                </SideSubMenu>
            )}
        </>
    );
}
